module.exports = __webpack_public_path__ + "img/open-full-screen.39c08bce.svg";